import { HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CORRELATION_HEADER } from './correlation-id.interceptor';

export const loggingInterceptor: HttpInterceptorFn = (req, next) => {
  if (environment.production) {
    return next(req);
  }

  const correlationId = req.headers.get(CORRELATION_HEADER);
  const started = performance.now();

  return next(req).pipe(
    tap({
      next: () => {
        const ms = Math.round(performance.now() - started);
        console.debug(`[http] ${req.method} ${req.url} ${ms}ms`, { correlationId });
      },
      error: () => {
        const ms = Math.round(performance.now() - started);
        console.debug(`[http] ${req.method} ${req.url} failed after ${ms}ms`, { correlationId });
      },
    })
  );
};
